import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BdbRequest } from '@npm-bbta/bbog-cm-auth-lib';
import { environment } from '../../../environments/environment';
import { ResponseFromFetch } from '@npm-bbta/bbog-cm-auth-lib/models/response-from-fetch.model';
import { BdbRequestService } from './bdb-request.service';
import { SandboxRequestService } from './sandbox/sandbox-request.service';
import { decompressBody } from './util/Decompress';
@Injectable()
export class DispatcherService {

    constructor(
        private bdbRquest: BdbRequest,
        private readonly sandboxRequestService: SandboxRequestService,
        public readonly bdbRequestService: BdbRequestService
    ) { }

    saveInfoAuthenticated(jsonData: any): Observable<any> {
        return this.bdbRquest.requestPostHeaders(environment.UrlWSRnec + 'authentication/dispatcher', jsonData);
    }

    getInfoFromUuid(uuid): Observable<any> {
        return this.bdbRquest.requestGet(environment.UrlWSRnec + 'authentication/dispatcher', { uuid: uuid });
    }

    public saveInfoDispacherSandbox(jsonData: any)  {
        const url = environment.authenticatorEndpointSandboxV3 + '/authentication/dispatcher/v3';
        const params = jsonData;
        const headers = this.bdbRequestService.getDispatcherHeaders();
        return this.sandboxRequestService.requestPostSandbox(url, params, headers, true);
    }

    public async getInfoFromUuidSandbox(uuid): Promise<ResponseFromFetch> {
        const url = environment.authenticatorEndpointSandboxV3 + '/authentication/dispatcher/v3';
        const params = { uuid };
        const headers = this.bdbRequestService.getDispatcherHeaders();
        const response = await this.sandboxRequestService.requestGetSandbox(url, headers, params);
        return decompressBody(response.body);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/dispatcher.service.ts